<app-page-title
    *ngIf="title"
    [title]="title"
></app-page-title>

<div
    class="row"
    *ngIf="orderDetail"
>
    <div class="col-md-12">
        <p>Order Date: {{orderDetail.dateCreatedUtc | customDate: 'formatDateTime'}}</p>
    </div>
    <div class="col-md-12 shipping-addresses">
        <div class="row">
            <div class="col-md-6">
                <div>
                    <h5>BILL TO:</h5>
                    <div>{{orderDetail.billingAddress.fullName}}</div>
                    <div *ngIf="orderDetail.billingAddress.suite">{{orderDetail.billingAddress.suite}}</div>
                    <div>{{orderDetail.billingAddress.addressLine1}}</div>
                    <div>{{orderDetail.billingAddress.city}}, {{orderDetail.billingAddress.regeionAbbrOrName}} {{orderDetail.billingAddress.postalCode}}</div>
                    <div>{{orderDetail.billingAddress.countryName}}</div>
                </div>
            </div>
            <div class="col-md-6">
                <div>
                    <h5>SHIP TO:</h5>
                    <div>{{orderDetail.shippingAddress.fullName}}</div>
                    <div *ngIf="orderDetail.shippingAddress.suite">{{orderDetail.shippingAddress.suite}}</div>
                    <div>{{orderDetail.shippingAddress.addressLine1}}</div>
                    <div>{{orderDetail.shippingAddress.city}}, {{orderDetail.shippingAddress.regeionAbbrOrName}} {{orderDetail.shippingAddress.postalCode}}</div>
                    <div>{{orderDetail.shippingAddress.countryName}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12">
        <table class="table table-condensed">
            <thead>
                <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of orderDetail.orderItems">
                    <td>
                        {{item.product.name}}
                        <div *ngIf="item.description">
                            <strong>{{item.description}}</strong>
                        </div>
                        <div
                            *ngIf="item.discountAmount"
                            class="saving"
                        >You saved {{item.discountAmount | currency : orderDetail.currencyCode : ""}}</div>
                    </td>
                    <td>{{item.quantity}}</td>
                    <td>
                        <div *ngIf="item.discountAmount">
                            <s>{{item.originalPrice | currency : orderDetail.currencyCode : ""}}</s>
                        </div>
                        <div [ngStyle]="item.discountAmount ? {'color': 'red'} : {}">
                            {{item.price | currency : orderDetail.currencyCode : ""}}
                        </div>
                    </td>
                    <td class="grey">{{item.price * item.quantity | currency : orderDetail.currencyCode : ""}}</td>
                </tr>

                <tr
                    *ngIf="totalSavings"
                    class="saving"
                >
                    <td></td>
                    <td></td>
                    <td>
                        Total saving
                    </td>
                    <td class="grey">
                        {{totalSavings | currency : orderDetail.currencyCode : ""}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td>Shipping And Handling Fee</td>
                    <td class="grey">{{orderDetail.shipping | currency : orderDetail.currencyCode : ""}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td><strong>Sub Total</strong></td>
                    <td class="grey">{{orderDetail.subTotal | currency : orderDetail.currencyCode : ""}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td>Tax</td>
                    <td class="grey">{{orderDetail.tax | currency : orderDetail.currencyCode : ""}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td><strong>Total</strong></td>
                    <td class="grey">{{orderDetail.currencyCode}} {{orderDetail.total | currency : orderDetail.currencyCode : ""}}</td>
                </tr>
            </tbody>
        </table>

    </div>

    <div class="col-md-12 payment-type">
        <div class="pt-inner">
            <h5>PAYMENT TYPES</h5>
            <p>{{orderDetail.paymentTypeNames[0]}}</p>
        </div>
    </div>
</div>
